import ErrorIcon from '@mui/icons-material/Error';
import { useAtomValue } from 'jotai';
import { Box, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getOrderTotalsTolerances, isNumberEqualToTargetWithinTolerance } from '@kheops/utils';
import { orderAtom } from '../state/state';
import useCurrencyFormat from '../../hooks/useCurrencyFormat';

export default function OrderTaxFreeTotalPriceDisplay(): React.JSX.Element {
  const currencyFormat = useCurrencyFormat();
  const { t } = useTranslation(['order']);
  const order = useAtomValue(orderAtom);
  const { taxFreeTolerance } = getOrderTotalsTolerances(order.items);
  const hasDifferentPriceExclTax = !isNumberEqualToTargetWithinTolerance(
    order.total_price_to_pay_excl_tax!,
    order.total_price_excl_tax!,
    taxFreeTolerance,
  );
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    hasDifferentPriceExclTax
      ? (
        <Tooltip
          title={t('order:invoice_total_different_from_kheops_order')}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
              color: 'orange',
              alignItems: 'center',
            }}
          >
            <ErrorIcon />
            <Typography variant={isSmall ? 'titleSmall' : 'titleMedium'} sx={{ color: 'inherit' }}>{currencyFormat.format(order.total_price_to_pay_excl_tax!)}</Typography>
          </Box>
        </Tooltip>
      )
      : (<Typography variant={isSmall ? 'titleSmall' : 'titleMedium'} color="primary">{currencyFormat.format(order.total_price_to_pay_excl_tax!)}</Typography>)
  );
}
